import * as React from 'react';

import type { WosIconProps } from 'types/common_types';

function dreamPrints(props: WosIconProps) {
  const { className } = props;

  return (
    <svg viewBox="0 0 79 60" className={className}>
      <path
        fill="currentColor"
        d="M77.368 60h-75.789c-0.872 0-1.579-0.707-1.579-1.579v0-56.842c0-0.872 0.707-1.579 1.579-1.579v0h75.789c0.872 0 1.579 0.707 1.579 1.579v0 56.842c0 0.872-0.707 1.579-1.579 1.579v0zM3.158 56.842h72.632v-53.684h-72.632z"
      />
      <path
        fill="currentColor"
        d="M66.989 36.432v0c-0.52-1.676-1.54-3.071-2.883-4.048l-0.022-0.016c0.355-0.96 0.56-2.068 0.56-3.225 0-5.279-4.279-9.558-9.558-9.558-1.263 0-2.468 0.245-3.572 0.69l0.064-0.023c-1.658-6.364-7.354-10.986-14.129-10.986-7.397 0-13.508 5.509-14.452 12.648l-0.008 0.074c-6.394 0.448-11.411 5.745-11.411 12.214 0 0.014 0 0.027 0 0.041v-0.002c0 0.074 0 0.158 0 0.232v0.126c0.188 6.632 5.609 11.937 12.269 11.937 0.024 0 0.048-0 0.071-0h35.575c4.324-0.002 7.829-3.507 7.829-7.832 0-0.807-0.122-1.586-0.349-2.319l0.015 0.055zM59.495 43.474h-35.579c-4.967-0.026-9.005-3.971-9.178-8.9l-0-0.016v-0.158c0-0.053 0-0.105 0-0.168 0-4.941 3.886-8.974 8.768-9.21l0.021-0.001h0.442c2.997 0.026 5.655 1.455 7.352 3.662l0.016 0.022 0.347 0.463 2.263-2.105-0.295-0.379c-1.835-2.363-4.476-4.023-7.505-4.568l-0.074-0.011c0.914-5.53 5.661-9.695 11.38-9.695 6.314 0 11.442 5.077 11.525 11.371l0 0.008c0 0.358 0 0.716-0.053 1.053l-0.168 1.842 1.116-1.421c1.199-1.547 3.058-2.533 5.147-2.533 3.588 0 6.496 2.908 6.496 6.496 0 1.499-0.507 2.879-1.36 3.978l0.011-0.015-0.526 0.663 0.832 0.179c0.648 0.141 1.22 0.396 1.72 0.747l-0.015-0.010 0.295 0.221c0.598 0.49 1.071 1.112 1.378 1.822l0.012 0.031c0.22 0.526 0.348 1.137 0.348 1.778 0 0.030-0 0.060-0.001 0.089l0-0.004c-0.006 2.613-2.107 4.733-4.712 4.768l-0.003 0z"
      />
    </svg>
  );
}

export default dreamPrints;
